import React from 'react';

import { useTypedTranslation } from '@app/hooks';
import { booleanToYesNo } from '@app/helpers';
import { IAgentDetail, IWindowsLogonConfig } from '@app/models';
import { AgentViewType } from '@app/pages/authManager/dialogs/addAgent.dialog';

interface IProps {
    editAgentCallback: Function;
    agent: IAgentDetail;
    windowsConfig: IWindowsLogonConfig;
};

const ReadWindowsLogon: React.SFC<IProps> = ({ editAgentCallback, agent, windowsConfig }) => {
    const { translation } = useTypedTranslation();

    return (
        <div className='detailPage__section'>
            <div className='detailPage__section-head'>
                {translation('WINDOWS_LOGON_CONFIGURATION_TAB')}
            </div>
            <div className='detailPage__section-content'>
                <ul className='detailPage__list'>
                    <li>
                        <a id='editAgentLink' className='detailPage__list--primary-label' onClick={() => editAgentCallback(AgentViewType.editAgentExtendedView)}>{translation('EDIT')}</a>
                    </li>
                    <li>
                        <span className='detailPage__list--primary-label'>{translation('ENFORCE_2FA_ON_RDP')}</span>
                        <span className='detailPage__list--secondary-label'>{translation(booleanToYesNo(windowsConfig.RDPOnly2FA))}</span>
                    </li>
                    <li>
                        <span className='detailPage__list--primary-label'>{translation('AUTOMATICALLY_ATTEMPT_PUSH_ON_LOGON')}</span>
                        <span className='detailPage__list--secondary-label'>{translation(booleanToYesNo(windowsConfig.LogonWithPush))}</span>
                    </li>
                    {windowsConfig.HasOverridePassword &&
                        <li>
                            <span className='detailPage__list--primary-label'>{translation('OVERRIDE_PASSWORD')}</span>
                            <span className='detailPage__list--secondary-label'>********</span>
                        </li>
                    }
                    {windowsConfig.HasOverrideGroup &&
                        <>
                            <li>
                                <span className='detailPage__list--primary-label'>{translation('OVERRIDE_GROUP')}</span>
                                <span className='detailPage__list--secondary-label'>{windowsConfig.OverrideGroup}</span>
                            </li>

                            <li>
                                <span className='detailPage__list--primary-label'>{translation('OVERRIDE_GROUP_REQUIRES_2FA')}</span>
                                <span className='detailPage__list--secondary-label'>{translation(booleanToYesNo(windowsConfig.OverrideGroupRequires2FA))}</span>
                            </li>
                        </>
                    }
                    <li>
                        <span className='detailPage__list--primary-label'>{translation('HIDE_REMOTE_SESSIONS')}</span>
                        <span className='detailPage__list--secondary-label'>{translation(booleanToYesNo(windowsConfig.HideRemoteSessions))}</span>
                    </li>
                    <li>
                        <span className='detailPage__list--primary-label'>{translation('HAS_ALIAS_REDIRECT')}</span>
                        <span className='detailPage__list--secondary-label'>{translation(booleanToYesNo(windowsConfig.HasAliasRedirect))}</span>
                    </li>
                    {windowsConfig.HasAliasRedirect &&
                        <>
                            <li>
                                <span className='detailPage__list--primary-label'>{translation('ALIAS_DOMAIN')}</span>
                                <span className='detailPage__list--secondary-label'>{windowsConfig.OrgMappings[0].Domain}</span>
                            </li>

                            <li>
                                <span className='detailPage__list--primary-label'>{translation('ALIAS_REDIRECT')}</span>
                                <span className='detailPage__list--secondary-label'>{windowsConfig.OrgMappings[0].AliasFor}</span>
                            </li>

                            <li>
                                <span className='detailPage__list--primary-label'>{translation('ALIAS_HOMEREALM')}</span>
                                <span className='detailPage__list--secondary-label'>{windowsConfig.OrgMappings[0].homeRealm}</span>
                            </li>
                        </>
                    }
                    <li>
                        <span className='detailPage__list--primary-label'>{translation('ALLOW_OFFLINE_ACCESS')}</span>
                        <span className='detailPage__list--secondary-label'>{translation(booleanToYesNo(windowsConfig.AllowOfflineAccess))}</span>
                    </li>
                    {windowsConfig.AllowOfflineAccess &&
                        <li>
                            <span className='detailPage__list--primary-label'>{translation('ALLOW_OFFLINE_ACCESS_FOR_X_DAYS')}</span>
                            <span className='detailPage__list--secondary-label'>{windowsConfig.AllowOfflineAccessForXDays}</span>
                        </li>
                    }
                </ul>
            </div>
        </div>
    );
};

export default ReadWindowsLogon;